(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["checklist-voyage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var KEY = 'cv-checklist-v1';
    document.querySelectorAll('.cv-checklist').forEach(function (root) {
      var boxes = root.querySelectorAll('[data-cv-item]');
      var countEl = root.querySelector('[data-cv-count]');
      var totalEl = root.querySelector('[data-cv-total]');
      var resetBtn = root.querySelector('[data-cv-reset]');
      var saved = {};
      try { saved = JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) {}

      function update() {
        var n = 0;
        boxes.forEach(function (b) { if (b.checked) n++; });
        if (countEl) countEl.textContent = n;
      }
      if (totalEl) totalEl.textContent = boxes.length;

      boxes.forEach(function (b) {
        if (saved[b.id]) b.checked = true;
        b.addEventListener('change', function () {
          saved[b.id] = b.checked;
          try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) {}
          update();
        });
      });
      update();

      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          boxes.forEach(function (b) { b.checked = false; saved[b.id] = false; });
          try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) {}
          update();
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
